// biome-ignore-all lint/style/useNamingConvention: exisiting error

import {isIn3AcrossABTest} from '~/GalleryPB/experiments';

export const GalleryAssetName = {
  desktop: {
    composed: isIn3AcrossABTest() ? '800x600' : '600x600',
    standalone_legacy: '500x680_optimized',
    standalone: 'medium_gallery_asset',
    uyo_mask_legacy: '500x680_uyo_mask',
    uyo_mask: 'medium_uyo_mask',
  },
  mobile: {
    composed: isIn3AcrossABTest() ? '496x372' : '372x372',
    standalone_legacy: '250x340_optimized',
    standalone: 'small_gallery_asset',
    uyo_mask_legacy: '250x340_uyo_mask',
    uyo_mask: 'small_uyo_mask',
  },
};
